module.exports = __webpack_public_path__ + "static/net-5393354ac41316714910c77c95b09275.png";